module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-okergeel.bc422e73.svg";